<template>
  <div>
    <div class="uiBreadcrumb">
      <ul class="uiClrfix" v-if="lang == 'chs'">
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />首页</a>
        </li>
        <li><span>/</span><a class="cur">免责声明</a></li>
      </ul>
      <ul class="uiClrfix" v-else>
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />Home</a>
        </li>
        <li><span>/</span><a class="cur">Disclaimer</a></li>
      </ul>
    </div>
    <div class="center">
      <div class="about_main" v-if="lang == 'chs'">
        <h3 class="about_main_title">{{ mianText.title }}</h3>
        <div class="Section0">
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <b
              ><span style="font-weight: bold; font-size: 16px"
                ><font>内容和下载声明</font></span
              ></b
            ><b
              ><span style="font-weight: bold; font-size: 16px"
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="font-size: 16px"
              ><font>水木资产管理有限公司以及其子公司和分支机构（统称为</font
              ><font>“水木</font></span
            ><span style="font-size: 16px"><font>”</font></span
            ><span style="font-size: 16px"
              ><font
                >），致力于确保其网站上发布尔日期的信息准确性。尽管如此，水木并不保证信息的准确性、适应性、实用性、可靠性或完整性。因此，水木对任何不准确或疏漏不承担责任，也不接受第三方责任。使用此网站，从水木或其代理人通过此网站、电子邮件或其他交付方法获取的信息或文件，均由用户自己承担风险。水木不保证此网站的内容无误，也不保证其服务器和交付系统的可靠性，免受电脑病毒或其他有害元素的影响。</font
              ></span
            ><span style="font-size: 16px"><o:p></o:p></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="font-size: 16px"><o:p>&nbsp;</o:p></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="font-size: 16px"
              ><font
                >我们正在努力确认网站内容的全面性和准确性。然而，信息技术的固有性质和对多个数据源（包括第三方）的依赖性使水木无法保证通过此网站访问的数据的准确性。内容是发布或指定日期的当前内容，可能会由于后续市场事件或其他原因而过时。重要的是，水木没有义务更新网站或其中的内容。基于此网站的数据（无论其是否准确）做出的任何决定或行动，不使水木对您或第三方的任何损失负责。</font
              ></span
            ><span style="font-size: 16px"><o:p></o:p></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="font-size: 16px"><o:p>&nbsp;</o:p></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="font-size: 16px"
              ><font
                >此外，水木并不承诺此网站的下载将满足您的期望，且无中断、安全、无错误；也不保证下载的文件不含有电脑病毒或有害组件。确保数据、软件、计算机和设备的保护和备份，以及实施适当的病毒检测和保护措施，完全是用户的责任。水木将不承担任何因使用此网站、其内容或下载而产生的任何服务、替换或任何费用。</font
              ></span
            ><span style="font-size: 16px"><o:p></o:p></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span
              style="mso-ascii-
mso-hansi-font-size:16px;
"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <b
              ><span style="font-weight: bold; font-size: 16px"
                ><font>版权、商标、标志、专利和其他知识产权</font></span
              ></b
            ><b
              ><span style="font-weight: bold; font-size: 16px"
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="font-size: 16px"
              ><font
                >此网站上的所有信息相关的版权、商标、标志、专利和其他知识产权均为水木专有。这些权利不以任何形式授予、指派或转让给网站用户。未经水木明确的书面许可，严禁复制、复制或重新分发网站的信息，部分或全部。</font
              ></span
            ><span style="font-size: 16px"><o:p></o:p></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span
              style="mso-ascii-
mso-hansi-font-size:16px;
"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="font-size: 16px"
              ><font
                >用户应了解网站上的内容受版权和其他知识产权保护。除非法律明确许可，否则用户不得销售、修改、复制、分发、展示或发布他们不拥有的任何内容，也不得在与网站或其内容交往时侵犯任何实体的知识产权。</font
              ></span
            ><span style="font-size: 16px"><o:p></o:p></span>
          </p>
        </div>
      </div>
      <div class="about_main" v-else>
        <h3 class="about_main_title">{{ mianText.titleE }}</h3>
        <div class="Section0">
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <b
              ><span
                style="color: rgb(0, 0, 0); font-weight: bold; font-size: 16px"
                ><font>Content and Downloading Disclaimers</font></span
              ></b
            ><b
              ><span
                style="color: rgb(0, 0, 0); font-weight: bold; font-size: 16px"
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><font
                >Waterwood Asset Management Limited, along with its
                subsidiaries, and affiliates (jointly referred to as
                "Waterwood"), endeavors to ensure the accuracy of information
                presented on its website as of the publication date. Despite
                this, Waterwood does not guarantee the information's accuracy,
                suitability, usefulness, reliability, or completeness.
                Consequently, Waterwood accepts no liability for any
                inaccuracies or oversights, nor does it accept third-party
                liability. The utilization of this website, the receipt of
                information or documents from Waterwood or its agents, through
                this website, email, or other delivery methods, is undertaken at
                the user's own risk. Waterwood does not assure error-free
                content on this website or the reliability of its servers and
                delivery systems from computer viruses or other harmful
                elements.</font
              ></span
            ><span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><font
                >Efforts are in place to confirm that website content is
                comprehensive and accurate. Nonetheless, the inherent nature of
                information technology and reliance on multiple, including
                third-party, data sources preclude Waterwood from guaranteeing
                the accuracy of data accessed via this site. Content is current
                as of the published or indicated date and might become outdated
                due to subsequent market events or for other reasons.
                Importantly, Waterwood is not obligated to update the website or
                content therein. Any decisions or actions taken based on this
                website's data, whether accurate or not, do not make Waterwood
                liable for any losses to you or third parties.</font
              ></span
            ><span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><font
                >Additionally, Waterwood makes no promises that downloads from
                this website will fulfill your expectations, be uninterrupted,
                secure, or free of errors; nor does it guarantee that files for
                download are devoid of computer viruses or harmful components.
                The responsibility of ensuring data, software, computer, and
                equipment protection and backup, alongside implementing adequate
                virus detection and protection measures, falls solely on the
                user. Waterwood will not bear the costs for any servicing,
                replacement, or any expenses incurred from using this website,
                its content, or downloads.</font
              ></span
            ><span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <b
              ><span
                style="color: rgb(0, 0, 0); font-weight: bold; font-size: 16px"
                ><font
                  >Copyright, Trademark, Logo, Patent, and Other Intellectual
                  Property Rights</font
                ></span
              ></b
            ><b
              ><span
                style="color: rgb(0, 0, 0); font-weight: bold; font-size: 16px"
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><font
                >All copyright, trademark, logo, patent, and other intellectual
                property rights associated with the information on this site
                belong exclusively to Waterwood. These rights are not licensed,
                assigned, or transferred to users of the site in any form.
                Replication, reproduction, or redistribution of the site's
                information, in part or full, without Waterwood's explicit
                written permission is strictly prohibited.</font
              ></span
            ><span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="margin-bottom: 0; text-align: justify"
          >
            <span style="color: rgb(0, 0, 0); font-size: 16px"
              ><font
                >Users should be aware that content on the site is protected by
                copyright and other intellectual property rights (IPRs). Without
                clear permission by law, users are not allowed to sell, modify,
                replicate, distribute, display, or publish any content not owned
                by them, nor should they infringe upon the IPRs of any entity
                while engaging with the Site or its content.</font
              ></span
            ><span style="font-size: 16px; mso-font-kerning: 1pt"
              ><o:p></o:p
            ></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Disclaimer",
  data() {
    return {
      lang: "",
      mianText: {
        title: "免责声明",
        titleE: "Disclaimer",
      },
    };
  },
  methods: {},
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
      this.$store.commit("setLang", lang);
    } else {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
    }
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
@media print {
  .hidden {
    display: none;
  }
}
.uiBreadcrumb {
  width: 1200px;
  padding: 0 15px;
  margin: 15px auto;
  height: 19px;
}

.uiBreadcrumb ul li {
  float: left;
}

.uiBreadcrumb ul li:nth-child(1):hover a {
  color: #233a78;
}

.uiBreadcrumb ul li span {
  padding: 0 5px;
}

.uiBreadcrumb ul li a {
  color: #999;
  font-size: 14px;
}

.uiBreadcrumb ul li .cur {
  color: #333;
  font-size: 14px;
}
.center {
  width: 1200px;
  margin: auto;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.about_main {
  margin-top: 30px;
  min-height: 260px;
  line-height: 27px;
  padding: 60px 230px 90px;
  font-size: 18px;
}
.about_main_title {
  padding: 20px 0 30px;
}
</style>